import senaiLogo from '../../Footer/assets/image.png';
import sdecLogo from '../../Footer/assets/logo-sdec.png';
import adepeLogo from '../../Footer/assets/logo-adepe.png';

export function ReportFooter() {
  return (
    <footer className="report-footer mt-6 pt-4 border-t border-[#ddd] flex items-center gap-4">
      <img src={senaiLogo} alt="SENAI" className="h-8 w-auto object-contain" />
      <img src={sdecLogo} alt="SDEC" className="h-8 w-auto object-contain" />
      <img src={adepeLogo} alt="ADEPE" className="h-8 w-auto object-contain" />
    </footer>
  );
}
